<template>
  <div>
    <base-loader-bar :is-loading="loading" />

    <v-row class="hq-details-row">
      <v-col cols="4" class="hq-main-title-card">
        <div>
          <a href="/admin/vsdashboard" class="goback">
            <v-icon color="#5E5873">mdi-arrow-left</v-icon>Back</a
          >

          <div class="breadcrumb-block">
            <a href="/admin/dashboard" class="breadcrumb-link-home">Home</a>
            <v-icon>mdi-chevron-right</v-icon>
            <a href="/admin/vsdashboard" class="breadcrumb-link"
              >VS Portfolios</a
            >
          </div>

          <h1 class="heading">{{ portfolio?.name }}</h1>
          <div>
            <strong style="color: #5e5873">
              Managed By:
              <a :href="'/admin/contacts#' + portfolio?.mancoid">
                <span class="blue--text">
                  {{ portfolio?.manco?.name }}</span
                > </a
              ><br />

              Owned By:
              <a :href="'/admin/contacts#' + portfolio?.ownerid">
                <span class="blue--text">
                  {{ portfolio?.owner?.name }}</span
                > </a
              ><br />
            </strong>
          </div>
        </div>
      </v-col>

      <v-col cols="8">
        <v-row>
          <v-col cols="6" class="mt-3"></v-col>

          <v-col cols="3" class="mt-3">
            <v-card class="mx-auto new-note-card" flat>
              <v-list-item>
                <v-list-item-title class="text-h5 text-center">
                  Properties | Buildings
                </v-list-item-title>
              </v-list-item>
              <v-card-text>
                <v-row align="center">
                  <v-col class="text-h2 text-center">
                    <span v-if="vsbuildings">
                      {{ vsBuildingMax }} | {{ vsbuildings?.count }}
                    </span>
                    <span v-else>0</span>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="3" class="mt-3">
            <v-card class="mx-auto new-note-card" flat>
              <v-list-item>
                <v-list-item-title class="text-h5 text-center">
                  {{ thismonthlong }} Updates<br />
                  <small
                    >Checked {{ checkedBuildingsThisMonth }} of
                    {{ vsbuildings?.count }} Buildings</small
                  >
                </v-list-item-title>
              </v-list-item>
              <v-card-text>
                <v-row align="center">
                  <v-col class="text-h2 text-center">{{ progress }}%</v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <!-- Tabs Row -->
    <v-row class="hqSectTab">
      <v-col cols="12">
        <v-tabs fixed-tabs v-model="tab">
          <v-tabs-slider color="#069697 "></v-tabs-slider>
          <v-tab
            class="hq-tabs"
            v-for="(tab, i) in vstabs"
            :key="i"
            :class="'top-table-nav tab-' + i"
          >
            {{ tab }}
          </v-tab>
        </v-tabs>
      </v-col>
    </v-row>

    <v-tabs-items v-model="tab">
      <!-- Property Tab -->
      <v-tab-item>
        <v-card v-if="!vsbuildings" class="mx-auto vs-incentive-box" flat>
          <v-row align="center">
            <v-col cols="12">
              <v-card-text>
                <h3>There are currently NO managed properties</h3>
              </v-card-text>
            </v-col>
          </v-row>
        </v-card>

        <!-- Building Layout Start-->
        <build-create-dialog
          :show="showBuildEdit"
          :id="selectedID"
          :propId="selectedPropID"
          :showCreate.sync="showBuildEdit"
          :refreshTable.sync="dataChanged"
          v-if="showBuildEdit"
        />
                <base-custom-table
          v-if="vsbuildings"
          :header="buildheaders"
          :items="vsbuildings?.records"
          :search="search"
          :selectHide="false"
          :tableType="'Portfolios Properties'"
          :remove="[]"
          :isLoading="isLoading"
          :pageLimit="vsBuildingLimit"
          :pageLimit.sync="vsBuildingLimit"
          :show_limiter="true"
          :maxItems="vsBuildingMax"
          :vslist="true"
          :isDeletedState="true"
          :passedTemplates="[
            'linkedprop.address',
            'linkedprop.name',
            'customActions',
            'checked',
            'checkedBy',
          ]"
          :passedExpanded="expanded"
          :expanded.sync="expanded"
        >
          <template v-slot:tableHeaderSpot>
            <vs-filter-quick :vsPropsFilters.sync="vsPropsFilters" />
          </template>

          <!-- ITEM TEMPLATES -->
          <template v-slot:linkedprop.name="{ item }">
            <span v-if="item?.linkedprop?.id">
              <a :href="`/admin/property/${item.linkedprop.id}`">
                {{ item.linkedprop.name || "Unnamed property" }}
              </a>
            </span>
            <span v-else>—</span>
          </template>

          <template v-slot:linkedprop.address="{ item }">
            <span v-if="item?.linkedprop">
              {{ item.linkedprop.address || "—" }}
            </span>
            <span v-else>—</span>
          </template>

          <!-- EXPANDED COLUMN -->
          <template v-slot:tableEditItem="{ item }">
            <td
              :colspan="buildheaders.length"
              style="background-color: #fff"
              class="p-0 m-0"
            >
              <v-card class="vs-summary-box p-0 m-0" flat>
                <div>
                  <building-info
                    :building="item?.linkedbuilding"
                    :notab="true"
                    :editMode="showBuildUpdate"
                  >
                    <template v-slot:actions>
                      <i
                        class="fi fi-rr-edit"
                        @click="
                          selectedPropID = item?.linkedbuilding?.property;
                          selectedID = item?.linkedbuilding?.id;
                          showBuildEdit = !showBuildEdit;
                        "
                      ></i>
                      <base-log-pulse
                        :id="item?.linkedbuilding?.id"
                        :type="'building'"
                        :reload="dataChanged"
                      />
                    </template>

                    <template v-slot:editSection>
                      <!-- optional edit block -->
                    </template>
                  </building-info>

                  <div v-if="showNewListing">
                    <listing-section
                      :buildingData="item?.linkedbuilding"
                      :propertyData="item?.linkedbuilding?.propertyData"
                      :queryLimit="makeQuery(item?.linkedbuilding)"
                      :onlyVS="true"
                      :triggerDataChanged="dataChanged"
                      :refreshData.sync="dataChanged"
                    />

                    <v-expansion-panels class="vacanc-block">
                      <v-expansion-panel>
                        <v-expansion-panel-header>
                          <b> ARCHIVED LISTINGS</b>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <listing-section
                            :buildingId="item?.linkedbuilding?.id"
                            :propertyId="item?.linkedbuilding?.property"
                            :queryLimit="null"
                            :achiveMode="true"
                            :triggerDataChanged="dataChanged"
                            :refreshData.sync="dataChanged"
                          />
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </div>

                  <div v-else>
                    <unit-section
                      :building="item?.linkedbuilding"
                      :onlyVS="true"
                      :refreshTable.sync="dataChanged"
                      :triggerDataChanged="dataChanged"
                    />

                    <v-expansion-panels class="vacanc-block">
                      <v-expansion-panel>
                        <v-expansion-panel-header
                          >ARCHIVED UNITS</v-expansion-panel-header
                        >
                        <v-expansion-panel-content>
                          <unit-section
                            :building="item?.linkedbuilding"
                            :onlyDeleted="true"
                            :refreshTable.sync="dataChanged"
                            :triggerDataChanged="dataChanged"
                          />
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </div>
                </div>
              </v-card>
            </td>
          </template>

          <!-- CHECKED -->
          <template v-slot:checked="{ item }">
            <div
              v-for="(pc, i) in groupedVspropchecks[getBuildingKey(item)] || []"
              :key="i"
            >
              {{ pc.createdAt | getFormattedDDMYYYY }}
            </div>
            <span
              v-if="
                !(groupedVspropchecks[getBuildingKey(item)] || []).length
              "
              >—</span
            >
          </template>

          <template v-slot:checkedBy="{ item }">
            <div
              v-for="(pc, i) in groupedVspropchecks[getBuildingKey(item)] || []"
              :key="i"
            >
              {{ pc.checkBy || "—" }}
            </div>
            <span
              v-if="
                !(groupedVspropchecks[getBuildingKey(item)] || []).length
              "
              >—</span
            >
          </template>

          <!-- ACTIONS -->
          <template v-slot:customActions="{ item }">
            <i
              class="fi fi-rs-trash"
              title="Remove Property from Managed By"
              @click="delink(item.id)"
            ></i>
            <i
              v-show="(groupedVspropchecks[getBuildingKey(item)] || []).length"
              class="fi fi-rr-checkbox"
            ></i
            >
            <i
              v-show="!(groupedVspropchecks[getBuildingKey(item)] || []).length"
              @click="checkedProp(item)"
              class="fi fi-rr-square-x checkbutton"
            ></i>
          </template>

          <!-- PAGINATION -->
          <template v-slot:tablePagination>
            <v-pagination
              class="text-center custom-pagination"
              v-model="vsBuildingPage"
              :length="Math.ceil(vsBuildingMax / vsBuildingLimit)"
              :total-visible="5"
              outlined
            ></v-pagination>
          </template>
        </base-custom-table>
        <!-- Building Layout End -->
      </v-tab-item>

      <!-- Map Tab -->
      <v-tab-item>
        <base-under-construction />
      </v-tab-item>

      <!-- Document Tab -->
      <v-tab-item>
        <v-dialog v-model="showAddDocument" width="800">
          <v-card>
            <v-card-title>
              <v-spacer></v-spacer>
              <v-icon color="primary" @click="showAddDocument = false"
                >mdi-close</v-icon
              >
            </v-card-title>

            <v-card-text>
              <vs-doc-create
                :portfolio="this.$route.params.id"
                :title="'Vacancy Schedule Document'"
                xxclose-edit.sync="editImages"
                :close-edit.sync="showAddDocument"
                :refreshTable.sync="dataChanged"
                :isMultiple="false"
              />
            </v-card-text>
          </v-card>
        </v-dialog>

        <base-custom-table
          :header="docheader"
          :items="vsdocuments?.records"
          :search="search"
          :selectHide="false"
          :tableType="'Documents'"
          :remove="[]"
          :isLoading="isLoading"
          :pageLimit="vsDocumentLimit"
          :pageLimit.sync="vsDocumentLimit"
          :show_limiter="true"
          :maxItems="vsDocumentMax"
          :passedTemplates="['size', 'uploadedBy', 'customActions']"
          :passedExpanded="expanded"
          :expanded.sync="expanded"
          :isDeletedState="true"
        >
          <template v-slot:customSlotBtns>
            <v-btn
              class="ml-2"
              @click="showAddDocument = !showAddDocument"
              elevation="0"
              color="#F37168"
            >
              <v-icon>mdi-plus</v-icon>
              Add Vacancy Schedule
            </v-btn>
          </template>

          <template v-slot:size="{ item }">
            {{ item.size | formatBytes }}
          </template>

          <template v-slot:uploadedBy="{ item }">
            {{ item.uploadedBy?.firstName }} {{ item.uploadedBy?.lastName }}
          </template>

          <template v-slot:customActions="{ item }">
            <a :href="item.documentLink">
              <i class="fi fi-rr-file-download" title="Download Document"></i>
            </a>
            <i
              class="fi fi-rs-trash"
              title="Delete Portfolio"
              @click="deleteVSDoc(item)"
            ></i>
          </template>

          <template v-slot:tablePagination>
            <v-pagination
              class="text-center custom-pagination"
              v-model="vsDocumentPage"
              :length="Math.ceil(vsDocumentMax / vsDocumentLimit)"
              :total-visible="5"
              outlined
            ></v-pagination>
          </template>
        </base-custom-table>
      </v-tab-item>

      <!-- Incentives Tab -->
      <v-tab-item>
        <vs-incentives :portid="portid" />
      </v-tab-item>

      <!-- Check History Tab -->
      <v-tab-item>
        <base-custom-table
          :header="checkheader"
          :items="vspropchecks?.records"
          :search="search"
          :selectHide="false"
          :tableType="'Check History'"
          :remove="['propertyid', 'buildingid', 'createdBy', 'portfolioid']"
          :isLoading="isLoading"
          :pageLimit="vsPropchecksLimit"
          :pageLimit.sync="vsPropchecksLimit"
          :show_limiter="true"
          :maxItems="vsPropchecksMax"
          :passedTemplates="['createdAt', 'customActions']"
          :passedExpanded="expanded"
          :expanded.sync="expanded"
          :isDeletedState="true"
        >
          <template v-slot:customSlotBtns></template>

          <template v-slot:createdAt="{ item }">
            {{ item.createdAt | getFormattedDDMYYYY }}
          </template>

          <template v-slot:tablePagination>
            <v-pagination
              class="text-center custom-pagination"
              v-model="vsPropchecksPage"
              :length="Math.ceil(vsPropchecksMax / vsPropchecksLimit)"
              :total-visible="5"
              outlined
            ></v-pagination>
          </template>
        </base-custom-table>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import { gql } from "apollo-boost";
import VsDocCreate from "@/components/Base/VsAdmin/VsDocCreate";
import VsFilterQuick from "@/components/Base/Property/VsFilterQuick";
import VsIncentives from "@/components/Base/VsAdmin/Incentives";
import BuildingInfo from "@/components/Base/Property/PropertyBlocks/BuildingBlocks/BuildingInfo";
import UnitSection from "@/components/Base/Property/PropertyBlocks/BuildingBlocks/UnitSection";
import ListingSection from "@/components/Base/Listings/ListingSection";
import BuildCreateDialog from "@/components/Base/Property/BuildCreateDialog";
import moment from "moment";
import groupBy from "lodash/groupBy";

export default {
  components: {
    VsDocCreate,
    VsFilterQuick,
    BuildingInfo,
    ListingSection,
    BuildCreateDialog,
    UnitSection,
    VsIncentives,
  },
  data() {
    return {
      loading: true,
      unitItem: [],
      isSale: false,
      unitid: null,
      optionLike: false,
      optionType: null,
      pushType: null,
      vsPropsFilters: null,
      finalVSBuildingFilters: {},
      groupedVsUnits: [],
      groupedProp: [],
      groupedUnits: [],
      checkthismonth: [],
      hideSet: null,
      selectedTab: null,
      dataChanged: null,
      showAddUnit: false,
      showBuildUpdate: false,
      unit: false,
      build: false,
      buildPortal: false,
      updatePortal: false,
      buildVS: false,
      center: {
        lat: -25.98590582330012,
        lng: 28.122702265864213,
      },
      isLoading: true,
      progress: 0,
      propcount: 0,
      zoom: 7,
      page: 1,
      pageCount: 0,
      itemsPerPage: 15,
      expanded: [],
      singleExpand: true,
      tab: null,
      showAddDocument: false,
      portid: this.$route.params.id,
      vstabs: [
        "Properties",
        "Map View",
        "Vacancy Schedules",
        "Incentives",
        "Check History",
      ],

      buildheaders: [
        {
          text: "Property Name",
          align: "start",
          sortable: true,
          value: "linkedprop.name",
          selected: true,
        },
        {
          text: "Address",
          align: "start",
          sortable: true,
          value: "linkedprop.address",
          selected: true,
        },
        {
          text: "Building Name",
          align: "start",
          sortable: true,
          value: "linkedbuilding.name",
          selected: true,
        },
        {
          text: "ERF#",
          align: "start",
          sortable: true,
          value: "linkedprop.erfNo",
          selected: true,
        },
        {
          text: "ERF Size",
          align: "start",
          sortable: true,
          value: "linkedprop.erfSize",
          selected: true,
        },
        {
          text: "Owner Type",
          align: "start",
          sortable: true,
          value: "linkedprop.ownershipType",
          selected: true,
        },
        {
          text: "Property Type",
          align: "start",
          sortable: true,
          value: "linkedprop.propertyType",
          selected: true,
        },
        {
          text: "Checked By",
          align: "center",
          sortable: false,
          value: "checkedBy",
          selected: true,
        },
        {
          text: "Checked",
          align: "center",
          sortable: false,
          value: "checked",
          selected: true,
        },
        {
          text: "Actions",
          align: "end",
          sortable: false,
          value: "actions",
          selected: true,
        },
      ],
      docheader: [
        {
          text: "VS Name",
          align: "start",
          sortable: true,
          value: "vsname",
          selected: true,
        },
        {
          text: "Uploaded By",
          align: "start",
          sortable: true,
          value: "uploadedBy",
          selected: true,
        },
        {
          text: "File Size",
          align: "start",
          sortable: true,
          value: "size",
          selected: true,
        },
        {
          text: "Upload Date",
          align: "start",
          sortable: true,
          value: "createdAt",
          selected: true,
        },
        {
          text: "Actions",
          align: "end",
          sortable: false,
          value: "actions",
          selected: true,
        },
      ],
      checkheader: [
        {
          text: "Property Name",
          align: "start",
          sortable: true,
          value: "propName",
          selected: true,
        },
        {
          text: "Building Name",
          align: "start",
          sortable: true,
          value: "buildingName",
          selected: true,
        },
        {
          text: "Checked By",
          align: "start",
          sortable: true,
          value: "checkBy",
          selected: true,
        },
        {
          text: "Checked At",
          align: "start",
          sortable: true,
          value: "createdAt",
          selected: true,
        },
      ],

      search: "",

      vsBuildingLimit: 100,
      vsBuildingPage: 1,
      vsBuildingMax: null,

      vsDocumentLimit: 100,
      vsDocumentPage: 1,
      vsDocumentMax: null,

      vsPropchecksLimit: 100,
      vsPropchecksPage: 1,
      vsPropchecksMax: null,

      groupedVspropchecks: {},

      selectedPropID: null,
      selectedID: null,
      showBuildEdit: false,
      showNewListing: true,
    };
  },

  apollo: {
    me: gql`
      query {
        me {
          id
          email
          firstName
          lastName
          role
        }
      }
    `,

    portfolio: {
      query: gql`
        query Portfolio($id: ID!) {
          portfolio(id: $id) {
            id
            name
            mancoid
            ownerid
            manco {
              id
              name
            }
            owner {
              id
              name
            }
            checked_percent
            update_period
            propcount
            active
            irregular
            createdBy
            createdAt
            updatedAt
          }
        }
      `,
      fetchPolicy: "network-only",
      variables() {
        return { id: this.$route.params.id };
      },
    },

    vsbuildings: {
      query: gql`
        query vsbuildings($limit: Int!, $skip: Int!, $query: JSON!) {
          vsbuildings(limit: $limit, skip: $skip, query: $query) {
            records {
              id
              portfolioid
              propertyid
              buildingid
              checked
              checkedBy
              checkedAt
              checkedPerson {
                id
                firstName
                lastName
              }
              linkedprop {
                id
                name
                address
                ownershipType
                propertyType
                erfNo
                erfSize
                zoning
              }
              linkedbuilding {
                id
                name
                property
                propertyData {
                  id
                  name
                  erfSize
                  address
                  zoning
                  areas
                  p24Areas
                }
                size
                grade
                greenRating
                occupiedBy
                forSalePrice
                listingDate
                listingBroker {
                  id
                  firstName
                  lastName
                }
                activeBroker {
                  id
                  firstName
                  lastName
                }
                auctionBroker {
                  id
                  firstName
                  lastName
                }
                acquiredSource
                buildingVacancyPercentage
                buildingScorecard
                website
                hqName {
                  name
                }
                estimateSize
                forSale
                onAuction
                buildingType
                auctionDate
                auctionVenue
                buildingSpaceBreakdown
                parkingBreakdown
                noneCostItems
                features
                headline
                description
              }
            }
            count
          }
        }
      `,
      fetchPolicy: "network-only",
      errorPolicy: "all",
      variables() {
        const limit = this.vsBuildingLimit;
        const skip = limit * this.vsBuildingPage - limit;

        let query = { portfolioid: this.$route.params.id };
        if (Object.values(this.finalVSBuildingFilters).length > 0) {
          query = { ...query, ...this.finalVSBuildingFilters };
        }

        return { limit, skip, query };
      },
      result({ data }) {
        this.vsBuildingMax = data?.vsbuildings?.count || 0;
        this.loading = false;
      },
      watchLoading(isLoading) {
        this.isLoading = isLoading;
      },
    },

    vsunits: {
      query: gql`
        query Vsunits($limit: Int!, $skip: Int!, $query: JSON!) {
          vsunits(limit: $limit, skip: $skip, query: $query) {
            records {
              id
              name
              building
              property
              availability
              type
              size
              listingDate
              toLet
              glaSet
              glaTotal
              grossCosts
              grossTotal
              grossRate
              parking
              parkingTotal
              otherCostItem
              documents {
                id
              }
              otherTotal
              otherFinalTotal
              listingBroker {
                id
              }
              activeBroker {
                id
              }
              aquiredSource
              features
              createdAt
              updatedAt
            }
          }
        }
      `,
      fetchPolicy: "network-only",
      skip() {
        return !this.vsbuildings?.records;
      },
      variables() {
        const limit = 300;
        const ids = (this.vsbuildings?.records || [])
          .map((e) => e.buildingid)
          .filter(Boolean);
        return { limit, skip: 0, query: { building: { $in: ids } } };
      },
      result({ data }) {
        const recs = data?.vsunits?.records || [];
        const normalized = recs.map((r) => ({
          ...r,
          aquiredSource: "Vacancy Schedule",
        }));
        this.groupedVsUnits = groupBy(normalized, "building");
      },
    },

    vspropchecks: {
      query: gql`
        query Vspropchecks($limit: Int!, $skip: Int!, $query: JSON!) {
          vspropchecks(limit: $limit, skip: $skip, query: $query) {
            records {
              id
              portfolioid
              buildingid
              propertyid
              createdBy
              createdAt
              checkBy
              buildingName
              propName
            }
            count
          }
        }
      `,
      fetchPolicy: "network-only",
      skip() {
        return !this.vsbuildings?.records;
      },
      variables() {
        const now = new Date();
        const year = now.getFullYear();
        const month = now.getMonth();

        // current month range (ms since epoch, matching your data)
        const startOfMonth = new Date(year, month, 1, 0, 0, 0, 0).getTime();
        const endOfMonth = new Date(
          year,
          month + 1,
          0,
          23,
          59,
          59,
          999
        ).getTime();

        return {
          limit: 999,
          skip: 0,
          query: {
            portfolioid: this.$route.params.id,
            createdAt: { $gte: startOfMonth, $lte: endOfMonth },
          },
        };
      },
      result({ data }) {
        const all = data?.vspropchecks?.records || [];

        this.vsPropchecksMax =
          data?.vspropchecks?.count || all.length || 0;

        this.checkthismonth = all;
        this.groupedVspropchecks = groupBy(all, "buildingid");

        const total = Number(this.vsbuildings?.count || 0);
        const doneDistinct = Object.keys(this.groupedVspropchecks).length;
        this.progress =
          total > 0 ? Math.round((doneDistinct / total) * 100) : 0;

        this.propcount = Number(this.vsBuildingMax || 0);

        this.StatsUpdate();
      },
    },

    vsdocuments: {
      query: gql`
        query vsdocuments($limit: Int!, $skip: Int!, $query: JSON!) {
          vsdocuments(limit: $limit, skip: $skip, query: $query) {
            records {
              id
              portfolio
              name
              vsname
              docClass
              documentFileName
              documentLink
              size
              createdBy
              createdAt
              updatedAt
              uploadedBy {
                lastName
                firstName
                id
              }
            }
            count
          }
        }
      `,
      fetchPolicy: "network-only",
      errorPolicy: "all",
      variables() {
        const limit = this.vsDocumentLimit;
        const skip = limit * this.vsDocumentPage - limit;
        return { limit, skip, query: { portfolio: this.$route.params.id } };
      },
      watchLoading(isLoading) {
        this.isLoading = isLoading;
      },
      result({ data }) {
        this.vsDocumentMax = data?.vsdocuments?.count || 0;
      },
    },
  },

  watch: {
    dataChanged() {
      this.$apollo.queries.portfolio?.refetch();
      this.$apollo.queries.vsdocuments?.refetch();
      this.$apollo.queries.vsbuildings?.refetch();
      this.$apollo.queries.vspropchecks?.refetch();
    },

    vsPropsFilters: {
      handler(newVal) {
        const filter = { ...newVal };
        this.finalVSBuildingFilters = {};
        const newFilter = {};

        if (filter?.name?.length > 0) {
          const propSearchtext = [
            { name: { $regex: filter.name, $options: "i" } },
            { address: { $regex: filter.name, $options: "i" } },
          ];
          newFilter.properties = { $or: propSearchtext };
          newFilter.buildings = {
            name: { $regex: filter.name, $options: "i" },
          };
          this.finalVSBuildingFilters = { ...newFilter };

          this.$apollo.queries.vsbuildings?.refetch();
        }
      },
      deep: true,
    },
  },

  computed: {
    thismonthlong() {
      return moment().format("MMMM 'YY");
    },
    checkedBuildingsThisMonth() {
      const g = this.groupedVspropchecks || {};
      return Object.keys(g).length;
    },
  },

  methods: {
    getBuildingKey(item) {
      return item?.buildingid || item?.linkedbuilding?.id || null;
    },

    makeQuery(args) {
      if (args) return { building: args.id, property: args?.property };
      else return { skip: true };
    },

    async StatsUpdate() {
      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation update($portfolio: PortfolioUpdateInput!) {
              updatePortfolio(portfolio: $portfolio) {
                id
                updated
              }
            }
          `,
          variables: {
            portfolio: {
              id: this.$route.params.id,
              checked_percent: this.progress,
              propcount: this.propcount,
            },
          },
        });
        if (response?.errors?.length) throw response.errors[0];
      } catch (e) {
        console.error("StatsUpdate failed:", e);
      }
    },

    async checkedProp(item) {
      try {
        await this.$apollo.mutate({
          mutation: gql`
            mutation updateVsbuilding($vsbuilding: VsbuildingUpdateInput!) {
              updateVsbuilding(vsbuilding: $vsbuilding) {
                id
                updated
              }
            }
          `,
          variables: {
            vsbuilding: {
              id: item.id,
              checkedBy: this.me.id,
              checked: true,
              checkedAt: new Date(),
            },
          },
        });

        await this.$apollo.mutate({
          mutation: gql`
            mutation createVspropcheck($vspropcheck: VspropcheckCreateInput!) {
              createVspropcheck(vspropcheck: $vspropcheck) {
                id
              }
            }
          `,
          variables: {
            vspropcheck: {
              createdBy: this.me.id,
              portfolioid: this.$route.params.id,
              buildingid: item.buildingid,
              propertyid: item.propertyid,
            },
          },
        });

        this.$apollo.queries.vsbuildings?.refetch();
        this.$apollo.queries.vspropchecks?.refetch();
      } catch (e) {
        console.error(e);
        throw (e && e.message) || e;
      }
    },

    AddVSUnit(name, index) {
      console.log("Add New VS Unit Clicked", name, index);
    },

    triggerToggle(name, index) {
      this.hideSet[index][name] = !this.hideSet[index][name];
    },

    editItem(item) {
      this.$router.push(`/admin/tags/${item.id}/edit`);
    },

    deleteVSDoc(item) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085D6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then(async (result) => {
        if (result.value) {
          try {
            const response = await this.$apollo.mutate({
              mutation: gql`
                mutation ($id: ID!) {
                  deleteVsdocument(id: $id) {
                    id
                    deleted
                  }
                }
              `,
              variables: { id: item.id },
            });
            if (response) {
              this.$swal(
                "Success!",
                "VS Document was successfully deleted",
                "success"
              );
              this.$apollo.queries.vsdocuments?.refetch();
            }
          } catch (e) {
            console.error(e);
          }
        }
      });
    },

    deleteItem(item) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085D6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then(async (result) => {
        if (result.value) {
          try {
            const response = await this.$apollo.mutate({
              mutation: gql`
                mutation ($id: ID!) {
                  deleteTag(id: $id) {
                    id
                    deleted
                  }
                }
              `,
              variables: { id: item.id },
            });

            if (response) {
              this.$swal("Success!", "Tag was successfully deleted", "success");
              this.$router.go(this.$route.currentRoute);
            }
          } catch (e) {
            console.error(e);
          }
        }
      });
    },

    delink(item) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085D6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delink building from portfolio!",
      }).then(async (result) => {
        if (result.value) {
          try {
            const response = await this.$apollo.mutate({
              mutation: gql`
                mutation ($id: ID!) {
                  deleteVsbuilding(id: $id) {
                    id
                    deleted
                  }
                }
              `,
              variables: { id: item },
            });

            if (response) {
              this.$swal(
                "Success!",
                "Portfolio was successfully deleted",
                "success"
              );
              this.$apollo.queries.vsbuildings?.refetch();
            }
          } catch (e) {
            console.error(e);
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.inline-icon {
  text-decoration: none;
}
.hq-sect-add.true #contact-edit-block {
  display: block !important;
}

.hq-sect-add #contact-edit-block.forceHide {
  display: none !important;
}

.hq-sect-add {
  margin-top: 30px;
}

.hq-sect-add .hq-ico-box {
  width: calc(100% - 100px);
  text-align: right;
  margin-bottom: 0px;
}

.mapLayer {
  position: relative;
}
.mapbox {
  padding: 0px !important;
  margin: 0px !important;
  background-color: #333;
  border-radius: 5px !important;
}

.googlemap {
  border-radius: 5px !important;
}
.property-header h1 {
  font-size: 35px;
  line-height: 30px;
  color: #2196f3;
  margin-bottom: 10px;
}

.property-header p {
  color: #000000;
  font-weight: 500;
}

.vs-dash-box {
  border: 1px solid #2196f3;
}

.v-data-table td {
  padding: 3px !important;
}

.table-inline-edit {
  background-color: #fff !important;
}

.vs-portfolio-list h2 {
  font-size: 18px;
  line-height: 30px;
  font-weight: 500;
}

.v-tabs .v-tabs-bar .v-tab.v-tab--active {
  color: rgba(0, 0, 0, 0.54);
}

.v-list-item {
  min-height: 38px !important;
}

.text-h2 {
  line-height: 1em !important;
  font-weight: 500 !important;
}

/*container*/
#contact-edit-block {
  margin-top: 0px !important;
  margin-bottom: 0px !important;
  display: none !important;
}
#contact-edit-block.show {
  display: block !important;
  box-shadow: none;
}
#contact-edit-block #contact-edit-block form > .row {
  height: 83px;
  background: #e0e0e0;
  border-radius: 5px 5px 0px 0px;
  margin-bottom: 5px;
}
#contact-edit-block #contact-edit-block form > .row h2 {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 21px;
  display: flex;
  align-items: center;
}
#contact-edit-block .contact-edit-fields {
  padding: 10px;
  background: #ebebeb;
}
#contact-edit-block .contact-edit-fields p {
  color: #333333;
  font-weight: 500;
  font-size: 14px;
  padding: 0;
  margin-bottom: 0px;
}
#contact-edit-block
  .contact-edit-fields
  .v-input:not(.v-input--checkbox)
  .v-input__slot,
#contact-edit-block .contact-edit-fields input {
  background-color: #fff !important;
}

.showHQcreate #contact-edit-block2 {
  display: block !important;
}

.showHQcreate #contact-edit-block2.forceHide {
  display: none !important;
}

.showHQcreate #contact-edit-block {
  display: block !important;
}

.showHQcreate #contact-edit-block.forceHide {
  display: none !important;
}

/*header*/
#contact-edit-block form > .v-card__text {
  height: 83px;

  background: #e0e0e0;
  border-radius: 5px 5px 0px 0px;
}

#contact-edit-block form > .v-card__text h2 {
  margin-top: 20px;
  font-weight: 400;
  font-size: 18px;
  line-height: 21px;
}

/*form box*/
#contact-edit-block .contact-edit-fields {
  padding: 15px 35px;
  margin-top: 2px;
  background: #ebebeb;
}

/*fields*/
#contact-edit-block .contact-edit-fields .col {
  padding: 20px;
}

#contact-edit-block .contact-edit-fields .col p {
  color: #000929;
  font-weight: 600;
  margin-top: 20px;
  margin-bottom: 8px;
  font-size: 14px;
}

#contact-edit-block .contact-edit-fields .col .v-input .v-label--active {
  display: none;
}

#contact-edit-block .contact-edit-fields .col .v-text-field--outlined fieldset {
  border-width: -0px;
}

/*buttons*/
.form-action-block.row .col-4 {
  text-align: right;
}

.form-action-block.row button.v-btn:not(.prop-edit-btn) {
  min-height: 48px;
  margin-bottom: 10px;
  text-transform: none;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  width: 141px;
  margin-right: 3px !important;
}

.form-action-block.row button.v-btn--outlined:not(.prop-edit-btn) {
  border-width: 3px;
}

/*override chevron*/
.mdi-menu-down::before {
  content: "\F035D";
}

.mdi-chevron-down::before {
  content: "\F0140";
}

.contact-edit-fields .mdi-menu-down::before {
  content: "\F0140" !important;
}

#contact-edit-block .contact-edit-fields {
  padding: 10px;
  background: #ebebeb;
}
#contact-edit-block .contact-edit-fields p {
  color: #333333;
  font-weight: 500;
  font-size: 14px;
  padding: 0;
  margin-bottom: 0px;
}
#contact-edit-block
  .contact-edit-fields
  .v-input:not(.v-input--checkbox)
  .v-input__slot,
#contact-edit-block .contact-edit-fields input {
  background-color: #fff;
}

/*new  date*/
.fake-input {
  background-color: #fff !important;
  padding: 5px;
  min-height: 48px;
  display: flex;
  border-radius: 3px;
}

.fake-input > * {
  padding-left: 2px;
  padding-right: 2px;
  min-height: 40px;
}

.fake-input .mdi:before {
  padding-top: 10px;
}

.fake-input .v-select__slot {
  min-height: 40px;
}

.fake-input .v-text-field__details {
  display: none;
}

/*new email sub btn*/

.email-with-sub {
  display: flex;
  margin-bottom: 0px !important;
}
.email-with-sub .v-input--checkbox {
  margin-top: 0px !important;
  padding-top: 0px;
  margin-left: 20%;
}

.email-with-sub .v-input--checkbox .v-input--selection-controls__ripple {
  margin: 0 7px;
  height: 30px;
  width: 30px;
  top: calc(50% - 20px);
}
.email-with-sub .v-input__slot {
  margin-bottom: 0px;
}
.email-with-sub .v-messages.theme--light {
  min-height: 7px;
}

.email-with-sub .v-input--selection-controls.v-input .v-label {
  padding-bottom: 10px;
}

#contact-edit-block .for-odd-field .v-input__slot {
  min-height: 56px !important;
  box-shadow: 0 1px 4px 0 rgb(0 0 0 / 1%) !important;
}

.for-odd-field.auto-field .v-text-field {
  padding-top: 0px;
  margin-top: 4px;
  border-radius: 4px;
}

.for-odd-field.auto-field
  .theme--light.v-text-field
  > .v-input__control
  > .v-input__slot:before {
  display: none;
}

.goback {
  margin-bottom: 10px;
  color: #5e5873;
}

.goback i {
  margin-right: 10px;
}

.hq-details-row {
  background-color: #fff;
  padding: 14px 25px 14px 25px;
  box-shadow: 0 4px 6px 0 rgba(32, 33, 36, 0.1);
  border-radius: 6px;
  margin-bottom: 30px;
}

button.v-btn {
  box-shadow: none;
}
.goback,
.hq-main-title-card .breadcrumb-block a {
  text-decoration: none;
  font-size: 16px;
  display: inline-block;
}

.hq-main-title-card {
  position: relative;
}

.floating-btn {
  position: absolute;
  right: 30px;
  top: 50px;
}

.hq-info-card.v-card {
  border-radius: 6px;
  margin-top: 0px;
  margin-bottom: 0px;
}
.action-set {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.hq-info-card .inline-chips {
  display: inline-block;
  width: 61%;
  float: right;
  text-align: left;
}

.hq-main-title-card .breadcrumb-block a.breadcrumb-link {
  font-weight: 600;
}

.hq-main-title-card .heading {
  color: #100a55;
  font-weight: 600;
  text-transform: uppercase;
  margin-bottom: 7px;
}

.hq-info-card.plan div {
  margin-bottom: 7px !important;
  color: #6e6b7b;
}
.hq-info-card.plan span:not(.v-chip) {
  display: inline-block;
  min-width: 39%;
}
.hq-info-card.plan a {
  text-decoration: none;
  color: #6e6b7b;
}
.hq-info-card.plan div.action-set {
  margin-bottom: 0 !important;
}

.hq-info-card > b {
  margin-bottom: 12px;
  display: inline-block;
}

.hq-info-card.green,
.hq-info-card.red {
  padding: 16px;
  border-radius: 14px;
}

.hq-info-card.green div,
.hq-info-card.red div {
  margin-bottom: 12px;
}

.hq-info-card.red {
  background-color: rgba(244, 67, 54, 0.1) !important;
  color: #6e6b7b;
}

.hq-info-card.green {
  background-color: rgba(143, 199, 192, 0.3) !important;
  color: #6e6b7b;
}
.hq-info-card.red b,
.hq-info-card.green b {
  color: #022e41;
}

.hq-info-card.green div b,
.hq-info-card.red div b {
  float: right;
  display: inline-block;
}

//Tab styling
.hq-tabs.v-tab {
  font-size: 14px;
  height: 37px;
  width: auto !important;
  color: #5e5873;
  font-weight: 600;
}

.v-window-item.v-window-item--active {
  padding-top: 20px;
}

//notes
.v-application:has(.custom-half-page-dialog) {
  overflow: hidden;
}

.v-sheet.v-card.new-note-card {
  box-shadow: none !important;
  border: #e2f0ee solid 2px;
  padding: 8px;
  border-radius: 8px;
}
.notes-space {
  height: 90%;
  overflow: auto;
  display: flex;
  flex-direction: column;
}

.notes-space .v-card {
  margin-top: auto;
}
.notes-space > b {
  color: #000929;
  font-weight: 600;
  opacity: 0.5;
  margin-bottom: 10px;
  display: block;
}

.single-note {
  font-size: 14px;
  font-weight: 600;
  text-transform: capitalize;
}

.single-note p {
  color: #000929;
  margin-bottom: 10px;
}

.single-note span {
  color: #000929;
  opacity: 0.5;
  margin-bottom: 10px;
  display: block;
}
.single-note hr {
  border-color: rgba(0, 9, 41, 0.1);
  margin-bottom: 23px;
}

.new-note-card .v-card p,
.note-title p {
  font-weight: 600;
  opacity: 0.5;
  font-size: 16px;
  display: inline-block;
}

.note-title .v-btn {
  float: right;
  font-size: 14px;
  padding: 10px 20px;
}

.all-notes {
  height: 110px;
  overflow: auto;
  width: 100%;
}
.new-note-card.v-card {
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);
  border-radius: 6px;
  margin-top: 0px;
  margin-bottom: 0px;
}

.schedule-card-box.v-card {
  padding: 20px 40px !important;
  box-shadow: none !important;
}

.text-h5 {
  font-weight: 600;
}

.text-h2 {
  font-weight: 700;
}

.checkbutton:hover {
  cursor: pointer;
}
</style>
